import { render, staticRenderFns } from "./ResourceItem.vue?vue&type=template&id=f69b22d4&scoped=true"
import script from "./ResourceItem.vue?vue&type=script&lang=js"
export * from "./ResourceItem.vue?vue&type=script&lang=js"
import style0 from "./ResourceItem.vue?vue&type=style&index=0&id=f69b22d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69b22d4",
  null
  
)

export default component.exports